exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.icon[data-v-4e1d77ff] {\n    cursor: pointer;\n    margin-right: 15px;\n}\n", ""]);

